import type { EnumTypeStates } from '@/features/states/models/state.schema'
import type { MyStateTransition } from '../services/negotiations-admin-v2.service'

export type StateWithCount = {
  id: string
  name: string
  type: EnumTypeStates
  color: string
  negotiations: number
}

/**
 * Cruza el catálogo de estados legibles con los conteos del summary.
 *
 * SON DOS RESPUESTAS Y NO UNA, a propósito. `/admin/negotiations/summary` es un
 * agregado: devuelve números indexados por `sta_` y ningún nombre, porque un
 * agregado no es un catálogo. Los nombres, colores y tipos salen de
 * `/me/state-transitions`, el mismo endpoint que alimenta los chips del tablero.
 * Publicar una tercera ruta que devolviera las dos cosas juntas —que es lo que
 * hacía `GET /negotiations/count-by-state`— obliga a mantener el catálogo en dos
 * lugares y a que no se desincronicen.
 *
 * **El catálogo manda.** Se recorre él, no los conteos: un `sta_` que aparezca en
 * el summary y no en el catálogo es un estado que este usuario NO puede leer, y
 * mostrarlo filtraría cuánto trabajo hay en una parte del negocio que no le toca.
 *
 * Un estado sin negociaciones cuenta **cero**, no desaparece: el summary sólo
 * trae las llaves que existen en el recorte consultado, así que la ausencia es lo
 * normal y no un borde.
 */
export function statesWithCounts(
  states: readonly MyStateTransition[],
  counts: Readonly<Record<string, number>>
): StateWithCount[] {
  return states.map((state) => ({
    id: state.id,
    name: state.name,
    type: state.type as EnumTypeStates,
    color: state.color,
    negotiations: counts[state.id] ?? 0
  }))
}
